export const state = {
  scope: {},
  quoteFlowSteps: [],
  variables: {},
  transactionTypes: []
}
